import {createApp, nextTick} from "vue";
const axios = require('axios');

export default {
    name: 'newsletter',
    _el: null,
    init() {
        this._el = document.querySelector('#js_newsletter');
        
        if(this._el){
            this.run(this._el);
        }
           
    },

    run (element)
    {
        createApp({
            delimiters: ['@{', '}'],
            data()   {
                return {
                    host        : "",
                    redirect    : "",
                    retailerId : null,
                    gdpr        : null,
                    honeypot    : false,
                    userId      : null,
                    responseStatus: null,
                    loading: false,
                }
            },

            created()
            {
                this.host           = document.querySelector('[name="site_root"]').content;
                this.redirect       = window.location.href;
                nextTick(this.enableForm);
            },

            methods:
            {
                enableForm() {
                    element.querySelector('.form').classList.add('is-ready');
                },

                prepareData() {
                    const token = document.querySelector('[name="CRAFT_CSRF_TOKEN"]');

                    const bodyFormData = new FormData();
                  
                    bodyFormData.append('email', this.userId);
                    bodyFormData.append('gdpr', this.gdpr);
                    bodyFormData.append('honeypot', document.getElementById('email').value);

                    return bodyFormData;
                },

                onSubmit(event) {
                    this.loading = true;
                    const headers = { "Content-Type": "multipart/form-data" };
                    const postData = this.prepareData();
                    const url = this.host+'actions/mm/newsletter/subscribe';

                    axios.post(url, postData, headers)
                        .then(this.onSubmit__callback)
                        .catch(this.onSubmit__error);
                },

                onSubmit__callback(response) {
                    if (typeof response === 'object' && typeof response.data === 'object') {
                        this.loading = false;
                        this.responseStatus = 'ok';
                        this.responseMessage = response.data.message;
                    }
                },

                onSubmit__error(error) {
                    this.loading = false;
                    this.responseStatus = 'error';
                    this.responseMessage = error;
                }
            }
        }).mount(element);
    }

}